module.exports = __webpack_public_path__ + "img/logo_microsoft.c183c047.svg";